<template>
  <InputListCard>
    <StateInputButton
      :value="name"
      required
      title="標題"
      rules="required"
      placeholder="輸入"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'name'})"
    />
    <StateDatePickerInput
      :value="announceAt"
      title="修正發布日"
      leadingIcon="icon-datestart"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'announceAt'})"
    />
    <StateDatePickerInput
      :value="effectAt"
      title="生效日"
      leadingIcon="icon-datestart"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'effectAt'})"
    />
    <LvUploadFileList
      :value="attaches"
      upload
      multiple
      showDeleteBtn
      uploadModule="guideline"
      class="mb-20"
      @go-to="$_onGoToFile($event)"
      @input="$emit('input', {value: $event, key: 'attaches'})"
    />
    <LvStateEffect
      :value="effects"
      :scrollTop="scrollTop"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'effects'})"
    />
    <LvStateGuidelineStatus
      :value="guidelineStatus"
      title="施行狀態"
      label="施行狀態"
      :scrollTop="scrollTop"
      :isCreatable="isCreatable"
      :isUpdatable="isUpdatable"
      :isDeletable="isDeletable"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'guidelineStatus'})"
    />
    <LlState
      :value="lawList"
      title="關聯法規"
      type="act-pick"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'lawList'})"
    />
    <LvPickGuideline
      :value="guidelineList"
      title="相關內規"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'guidelineList'})"
    />
    <WsInputTextareaButton001
      :value="content"
      autoSize
      title="內容"
      placeholder="輸入"
      :minHeight="0"
      :maxHeight="0"
      :rules="_rules"
      :required="_isRequired"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'content'})"
    />
    <LvWYSIWYGEditor
      :value="richContent"
      :rules="_rules"
      :required="_isRequired"
      title="內容(含html)"
      class="mb-20"
      @input="$emit('input', {value: $event, key: 'richContent'})"
    />
  </InputListCard>
</template>

<script>
import S_guidelineStatus from '@/service/api/v1/guidelineStatus';
import H_file from '@/helpers/file';
import H_guidelineStatus from '@/helpers/guidelineStatus';
import Spare_guidelineStatus from '@/spare/guidelineStatus';

export default {
  props: {
    name: {
      type: String,
    },
    type: {
      type: String,
    },
    announceAt: {
      type: String,
    },
    effectAt: {
      type: String,
    },
    attaches: {
      type: Array,
    },
    effects: {
      type: Array,
    },
    guidelineStatus: {
      type: String,
    },
    lawList: {
      type: Array,
    },
    content: {
      type: String,
    },
    richContent: {
      type: String,
    },
    scrollTop: {
      type: [Number, String],
    },
    factoryId: {
      type: String,
    },
    isCreatable: {
      type: Boolean,
      default: false,
    },
    isUpdatable: {
      type: Boolean,
      default: false,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
    guidelineList: {
      type: Array,
    },
  },
  computed: {
    _guidelineStatus() {
      return {
        createFields: Spare_guidelineStatus.createFields,
        updateFields: Spare_guidelineStatus.updateFields,
        setDeletePopupInfo: async (data) => await H_guidelineStatus.setDeletePopupInfo(data),
        getList: S_guidelineStatus.index,
        setList: H_guidelineStatus.setDropdownCustomItems,
        deleteItem: S_guidelineStatus.delete,
        updateItem: S_guidelineStatus.update,
      };
    },
    _isRequired() {
      return this.type === 'article';
    },
    _rules() {
      return this.type === 'article' ? 'required' : '';
    }
  },
  methods: {
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
  }
}
</script>